import { render, staticRenderFns } from "./ThemeNotifications.vue?vue&type=template&id=44b263ce"
import script from "./ThemeNotifications.vue?vue&type=script&lang=js"
export * from "./ThemeNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports